(() => {
  const COLLECTION_HANDLE = "bundles";
  const GIFT_PRODUCT_HANDLE = "coin-tray";

  let bundleVariantIds = [];
  let giftVariantId = null;

  const dispatchRefresh = () => {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  };

  const getVariantIdFromHandle = async (handle) => {
    const res = await fetch(`/products/${handle}.js`);
    const product = await res.json();
    return product.variants[0].id;
  };

  const getAllVariantsFromCollection = async (collectionHandle) => {
    const res = await fetch(`/collections/${collectionHandle}/products.json?limit=250`);
    const data = await res.json();
    const variants = [];

    data.products.forEach(product => {
      product.variants.forEach(variant => {
        variants.push(variant.id);
      });
    });

    return variants;
  };

  const getCart = async () => {
    const res = await fetch("/cart.js");
    return res.json();
  };

  const setGiftCount = async (n, cart) => {
    const giftLine = cart.items.find(item =>
      item.id === giftVariantId &&
      item.properties?._isFreeGift
    );

    if (giftLine) {
      const line = cart.items.findIndex(i => i.key === giftLine.key) + 1;
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line, quantity: n })
      });
    } else if (n > 0) {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: giftVariantId,
          quantity: n,
          properties: { _isFreeGift: true }
        })
      });
    }

    dispatchRefresh();
  };

  const syncFreeGift = async () => {
    const cart = await getCart();

    // Count all qualifying bundle items
    let bundleCount = 0;
    for (const item of cart.items) {
      if (bundleVariantIds.includes(item.id)) {
        bundleCount += item.quantity;
      }
    }

    const giftLine = cart.items.find(item =>
      item.id === giftVariantId &&
      item.properties?._isFreeGift
    );
    const currentGifts = giftLine ? giftLine.quantity : 0;

    if (currentGifts !== bundleCount) {
      await setGiftCount(bundleCount, cart);
    }
  };

  const init = async () => {
    bundleVariantIds = await getAllVariantsFromCollection(COLLECTION_HANDLE);
    giftVariantId    = await getVariantIdFromHandle(GIFT_PRODUCT_HANDLE);

    await syncFreeGift();

    document.addEventListener('cart:updated',    syncFreeGift);
    document.addEventListener('cart:refresh',    syncFreeGift);
    document.addEventListener('cart:line:added', syncFreeGift);
    document.addEventListener('cart:line:removed', syncFreeGift);

    const realFetch = window.fetch;
    window.fetch = async (...args) => {
      const url = args[0]?.toString();
      const res = await realFetch.apply(this, args);
      if (url.includes("/cart/add.js") || url.includes("/cart/change.js")) {
        setTimeout(syncFreeGift, 200);
      }
      return res;
    };
  };

  document.addEventListener("DOMContentLoaded", init);
})();
